export const GET_USERS_PENDING = 'GET_USERS_PENDING'
export const GET_USERS_SUCCESSFUL = 'GET_USERS_SUCCESSFUL'
export const GET_USERS_ERROR = 'GET_USERS_ERROR'
export const CLEAR_USERS = 'CLEAR_USERS'
export const GET_USERS = 'GET_USERS'
export const USER_SEARCH_LIMIT = 200
